function normalizePath(path: string): string {
  if (!path || path === '/') {
    return path || '';
  }
  return path.endsWith('/') ? path.slice(0, -1) : path;
}

export function resolveApiRequestUrl(requestUrl: string, apiBaseURL: string): string {
  if (/^https?:\/\//i.test(requestUrl)) {
    return requestUrl;
  }
  const base = apiBaseURL.replace(/\/+$/, '');
  const path = requestUrl.replace(/^\/+/, '');
  return `${base}/${path}`;
}

/**
 * True only when the request targets the configured API origin and path prefix.
 * Avoids attaching the Bearer token to lookalike hosts such as api.example.com.evil.
 */
export function isOwnApiUrl(requestUrl: string, apiBaseURL: string): boolean {
  try {
    const api = new URL(apiBaseURL);
    const request = new URL(requestUrl, api);
    if (request.origin.toLowerCase() !== api.origin.toLowerCase()) {
      return false;
    }
    const apiPath = normalizePath(api.pathname);
    const reqPath = normalizePath(request.pathname);
    if (!apiPath || apiPath === '/') {
      return true;
    }
    return reqPath === apiPath || reqPath.startsWith(`${apiPath}/`);
  } catch {
    return false;
  }
}
